namespace TabAurous.Production {
    export interface TreeMakingItemsRow {
        TransItemId?: number;
        TransId?: number;
        RefVoucherNo?: string;
        OrderTypeId?: number;
        MovementId?: number;
        TransDate?: string;
        VoucherNo?: string;
        UserId?: number;
        BagNo?: string;
        SubBagNo?: number;
        LotNo?: string;
        Line_No?: number;
        DepartmentId?: number;
        POSCustomerId?: number;
        EmployeeId?: number;
        LedgerName?: string;
        RefTransId?: number;
        RefTransItemId?: number;
        RefVoucherId?: number;
        ProductId?: number;
        ProductCode?: string;
        HasBom?: boolean;
        CalcOnId?: number;
        ItemTypeId?: number;
        AttributeId?: number;
        Attribute?: string;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondWeight?: number;
        DiamondPieces?: number;
        StoneWeight?: number;
        StonePieces?: number;
        OtherWeight?: number;
        OtherPieces?: number;
        Purity?: number;
        PureWeight?: number;
        DeliveryDate?: string;
        BOMDetails?: TreeMakingBOMRow[];
        StockAllocation?: boolean;
    }

    export namespace TreeMakingItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.TreeMakingItems';
        export const lookupKey = 'Production.TreeMakingItems';

        export function getLookup(): Q.Lookup<TreeMakingItemsRow> {
            return Q.getLookup<TreeMakingItemsRow>('Production.TreeMakingItems');
        }
        export const deletePermission = 'Production:TreeMaking:Delete';
        export const insertPermission = 'Production:TreeMaking:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:TreeMaking:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            RefVoucherNo = "RefVoucherNo",
            OrderTypeId = "OrderTypeId",
            MovementId = "MovementId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            DepartmentId = "DepartmentId",
            POSCustomerId = "POSCustomerId",
            EmployeeId = "EmployeeId",
            LedgerName = "LedgerName",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefVoucherId = "RefVoucherId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            HasBom = "HasBom",
            CalcOnId = "CalcOnId",
            ItemTypeId = "ItemTypeId",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondWeight = "DiamondWeight",
            DiamondPieces = "DiamondPieces",
            StoneWeight = "StoneWeight",
            StonePieces = "StonePieces",
            OtherWeight = "OtherWeight",
            OtherPieces = "OtherPieces",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DeliveryDate = "DeliveryDate",
            BOMDetails = "BOMDetails",
            StockAllocation = "StockAllocation"
        }
    }
}
